import { Flow, Text } from 'bold-ui'

import { imoveisSelecionadosTitle } from '../utils/utils-inativacaoImoveis'

interface InativacaoImoveisConfirmModalProps {
  numeroImoveis: number
}

export const InativacaoImoveisConfirmModal = ({ numeroImoveis }: Readonly<InativacaoImoveisConfirmModalProps>) => (
  <Flow direction='vertical' gap={1}>
    <Text>
      Imóveis inativados serão exibidos na aba "inativos" do Acompanhamento do território e não serão enviados ao
      aplicativo e-SUS Território nem contabilizados nos Relatórios Consolidados.
    </Text>
    <Text>Essa ação só pode ser desfeita individualmente em cada cadastro, através de uma atualização.</Text>
    <Text fontWeight='bold'>{imoveisSelecionadosTitle(numeroImoveis)}.</Text>
  </Flow>
)
